import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="powered-by-footer">
    <span>Powered by</span>
    <img src="https://cdn.attraxion.app/images/logos/AttraxionDark.png" alt="Attraxion" className="attraxion-logo" />
  </footer>
);

export default Footer;
